import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

//************************ Purchase Order Imports ***************************/
const LedgerTable = Loadable(
  lazy(() =>
    import("./LedgerTable").then(({ LedgerTable }) => ({
      default: LedgerTable,
    })),
  ),
);

export const ledgerRoutes = [
  {
    path: app_navbar_routes.app.ledger.ledger,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.LEDGER]}>
        <LedgerTable />
      </AuthorizedRoute>
    ),
  },
];
